'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _components2 = require('components');

var _SHARE = require('components/SHARE');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Static: {
        displayName: 'Static'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Order/ProcessInput/static.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Static = _wrapComponent('Static')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        currency: state.currency
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Static, _Component);

    function Static(props) {
        (0, _classCallCheck3.default)(this, Static);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Static.__proto__ || (0, _getPrototypeOf2.default)(Static)).call(this, props));

        _this.productsTable = function () {
            var currency = _this.props.currency;

            return _this.props.products.map(function (item) {
                var pictures = item.offer.pictures || [];
                var image = pictures[0];
                var quantity = parseInt(item.quantity, 10) || 0;
                var weight = null;
                var childWeight = null;
                var modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 prod_desc' },
                    _react3.default.createElement('div', { className: 'title' })
                );
                item.additionalInfo = item.additional_info ? JSON.parse(item.additional_info) : null;
                if (item.additionalInfo && item.additionalInfo.custom_fields) {
                    item.custom_fields = item.additionalInfo.custom_fields;
                }

                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
                    modifier_option_name = _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 prod_desc' },
                        _react3.default.createElement(
                            'div',
                            { className: 'title' },
                            item.modifier_option_name
                        )
                    );
                } else if (item.modifier_option_id !== null) {
                    modifier_option_name = _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 prod_desc' },
                        _react3.default.createElement(
                            'div',
                            { className: 'title' },
                            item.modifiedOption.name
                        )
                    );
                }
                return _react3.default.createElement(
                    'div',
                    { className: 'row no-margin cart-item' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-1 col-xs-12' },
                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : ''
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4' },
                        _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/product/' + item.offer.id },
                                    item.offer.name
                                )
                            ),
                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description }),
                            item.custom_fields ? item.custom_fields.map(function (product, i) {
                                return _react3.default.createElement(
                                    'label',
                                    null,
                                    product.name,
                                    ': ',
                                    product.value
                                );
                            }) : null
                        )
                    ),
                    modifier_option_name,
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'quantity cart_quantity' },
                            _react3.default.createElement(
                                'span',
                                { className: 'visible-xs' },
                                _this.props.lang['store.common.quantity'],
                                ': ',
                                quantity
                            ),
                            _react3.default.createElement(
                                'span',
                                { className: 'hidden-xs' },
                                quantity
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'price' },
                            _react3.default.createElement(
                                'span',
                                { className: 'visible-xs' },
                                _this.props.lang['store.common.price'],
                                ':',
                                _react3.default.createElement(_components2.MoneyValue, {
                                    value: parseFloat(item.price * quantity),
                                    icon: currency.icon,
                                    iconAfterValue: currency.icon_after_value
                                })
                            ),
                            _react3.default.createElement(
                                'span',
                                { className: 'hidden-xs' },
                                _react3.default.createElement(_components2.MoneyValue, {
                                    value: parseFloat(item.price * quantity),
                                    icon: currency.icon,
                                    iconAfterValue: currency.icon_after_value
                                })
                            )
                        )
                    ),
                    _react3.default.createElement('div', { className: 'clearfix' }),
                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
                        if (childItem.quantity == 0) {
                            return null;
                        }
                        weight = childItem.quantity / quantity;
                        childItem.weight_offer = childItem.weight_offer * 1;
                        if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
                            weight = childItem.weight_offer * childItem.quantity / quantity;
                            weight = weight.toFixed(3);
                            if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
                                weight = item.weight_offer * 1;
                            }
                            if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
                                weight = childItem.weight_offer * 1;
                            }
                        }
                        return _react3.default.createElement(
                            'div',
                            { className: 'row no-margin' },
                            _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-4 visible-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'title', style: { paddingLeft: '20px' } },
                                    '\u2022 ',
                                    childItem.name,
                                    ' ',
                                    childItem.modifier_option_name
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { style: { paddingLeft: '30px' } },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        _this.props.lang['store.common.quantity'],
                                        ': '
                                    ),
                                    childItem.type_id === 5 ? _react3.default.createElement(
                                        'span',
                                        null,
                                        childItem.quantity / quantity
                                    ) : _react3.default.createElement(
                                        'span',
                                        null,
                                        weight,
                                        ' ',
                                        _this.props.lang[childItem.unit.title_lang_data]
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-4 hidden-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'title', style: { paddingLeft: '20px' } },
                                    '\u2022 ',
                                    childItem.name
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-3 hidden-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'title' },
                                    childItem.modifier_option_name
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2 hidden-xs' },
                                _react3.default.createElement(
                                    'div',
                                    { style: { textAlign: 'center' } },
                                    _react3.default.createElement(
                                        'span',
                                        { className: 'visible-xs' },
                                        _this.props.lang['store.common.quantity'],
                                        ': '
                                    ),
                                    childItem.type_id === 5 ? _react3.default.createElement(
                                        'span',
                                        null,
                                        childItem.quantity / quantity
                                    ) : _react3.default.createElement(
                                        'span',
                                        null,
                                        weight,
                                        ' ',
                                        _this.props.lang[childItem.unit.title_lang_data]
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-xs-12 col-sm-2' },
                                _react3.default.createElement('div', { className: 'price' })
                            ),
                            _react3.default.createElement('div', { className: 'clearfix' }),
                            childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
                                if (childChildItem.quantity == 0) {
                                    return null;
                                }
                                childWeight = childChildItem.quantity / childItem.quantity;
                                childChildItem.weight_offer = childChildItem.weight_offer * 1;
                                if ((childChildItem.unit.slug === 'kg' || childChildItem.unit.slug === 'mg') && childChildItem.weight_offer && childChildItem.weight_offer > 0 && childChildItem.quantity > 0) {
                                    childWeight = childChildItem.weight_offer * childChildItem.quantity / childItem.quantity;
                                    childWeight = childWeight.toFixed(3);
                                    if (childChildItem.weight_offer < 0.01 && childChildItem.quantity < 1 || childChildItem.weight_offer < 1 && childChildItem.quantity < 0.01) {
                                        childWeight = childChildItem.weight_offer * 1;
                                    }
                                    if (childChildItem.weight_offer < 0.1 && childChildItem.quantity < 0.1) {
                                        childWeight = childChildItem.weight_offer * 1;
                                    }
                                }
                                if (childItem.quantity === 0) {
                                    childWeight = 0;
                                }
                                return _react3.default.createElement(
                                    'div',
                                    { className: 'row no-margin' },
                                    _react3.default.createElement('div', { className: 'col-sm-1 col-xs-12' }),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-sm-4 visible-xs' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'title', style: { paddingLeft: '40px' } },
                                            '- ',
                                            childChildItem.name,
                                            ' ',
                                            childChildItem.modifier_option_name
                                        ),
                                        _react3.default.createElement(
                                            'div',
                                            { style: { paddingLeft: '49px' } },
                                            _react3.default.createElement(
                                                'span',
                                                null,
                                                _this.props.lang['store.common.quantity'],
                                                ': ',
                                                childWeight,
                                                ' ',
                                                _this.props.lang[childChildItem.unit.title_lang_data]
                                            )
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-4 hidden-xs' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'title', style: { paddingLeft: '40px' } },
                                            '- ',
                                            childChildItem.name
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-3 hidden-xs' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'title' },
                                            childChildItem.modifier_option_name
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-2 hidden-xs' },
                                        _react3.default.createElement(
                                            'div',
                                            { style: { textAlign: 'center' } },
                                            _react3.default.createElement(
                                                'span',
                                                { className: 'visible-xs' },
                                                _this.props.lang['store.common.quantity'],
                                                ': '
                                            ),
                                            _react3.default.createElement(
                                                'span',
                                                null,
                                                childWeight,
                                                ' ',
                                                _this.props.lang[childChildItem.unit.title_lang_data]
                                            )
                                        )
                                    ),
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'col-xs-12 col-sm-2' },
                                        _react3.default.createElement('div', { className: 'price' })
                                    )
                                );
                            }) : null
                        );
                    }) : null
                );
            });
        };

        return _this;
    }

    (0, _createClass3.default)(Static, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                lang = _props.lang,
                currency = _props.currency,
                sumTotal = _props.sumTotal;

            var data = this.props.data.result;
            var date = (0, _moment2.default)(this.props.data.result.operation.crtime);

            if (data.error > 0) {
                return _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 process_input' },
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'p',
                            null,
                            _react3.default.createElement(_components2.TranslatePipo, { title: data.message }),
                            _react3.default.createElement('br', null)
                        )
                    )
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 process_input' },
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'small-9 columns' },
                        _react3.default.createElement(
                            'h2',
                            { className: 'section-title special_title' },
                            lang['store.common.order'],
                            ' \u2116',
                            this.props.orderId
                        ),
                        _react3.default.createElement(
                            'h5',
                            null,
                            '' + date.format('DD.MM.YYYY')
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'small-12 columns' },
                        _react3.default.createElement(
                            'p',
                            null,
                            _react3.default.createElement(_components2.TranslatePipo, { title: data.labels.part3 })
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row', id: 'personal-order-detail' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 items-holder no-margin' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row no-margin cart-item hidden-xs' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-1' },
                                lang['store.cart.photo']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-4' },
                                lang['store.cart.title']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-3' },
                                lang['store.cart.modifiers']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-2 text-center' },
                                lang['store.cart.quantity']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'col-sm-2 text-center' },
                                lang['store.cart.price']
                            )
                        ),
                        this.productsTable()
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 products_total_price' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-3 col-sm-offset-9 text-center' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(sumTotal),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value,
                                prefix: lang['store.cart.total'] + ': '
                            })
                        )
                    )
                )
            );
        }
    }]);
    return Static;
}(_react2.Component), _class2.propTypes = {
    data: _react2.PropTypes.object,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Static;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/ProcessInput/static.jsx
// module id = 1711
// module chunks = 0